



























import { Component, Vue } from 'vue-property-decorator'

import type { BreadcrumbsItem } from '@/components/lib/Breadcrumbs.vue'

import { security } from '@/store/modules/security'
import { settings } from '@/store/modules/settings'
import Breadcrumbs from '@/components/lib/Breadcrumbs.vue'

@Component({
  components: {
    Breadcrumbs,
  },
})
class LoyaltyView extends Vue {
  securityModule = security.context(this.$store)
  settingsModule = settings.context(this.$store)

  breadcrumbsItems: Array<BreadcrumbsItem> = [
    {
      text: 'Главная',
      disabled: false,
      to: { name: 'main' },
    },
    {
      text: this.$route.meta.title,
      disabled: true,
    },
  ]
}

export default LoyaltyView
